export default "__VITE_ASSET__BSyXWoEm__"